import { Dispatch, SetStateAction, createContext } from 'react'

import { CustomFormPermissions } from './Provider'
import { CustomForm, CustomFormQuestion } from '../../../../types'

export type CustomFormBuilderProps = {
  isFormActionsDisabled: boolean
  canUpdateFormVisibility: boolean
  canUpdateForm: boolean
  canDeleteForm: boolean
  permissions?: CustomFormPermissions
  form?: CustomForm
  questions: CustomFormQuestion[]
  setQuestions: Dispatch<SetStateAction<CustomFormQuestion[]>>
  setForm: Dispatch<SetStateAction<CustomForm | undefined>>
  updateForm: (data: any) => Promise<any>
  updateFormVisibility: (data: any) => Promise<any>
  deleteForm: () => Promise<any>
  getQuestion: (questionSlug?: string) => Promise<any>
  readQuestions: () => Promise<void>
  createQuestion: (data: any) => Promise<boolean>
  updateQuestion: ({ questionId, data }: any) => Promise<boolean>
  deleteQuestion: (questionId?: string) => Promise<boolean>
}

const defaultValues = {
  isFormActionsDisabled: false,
  canUpdateFormVisibility: false,
  canUpdateForm: false,
  canDeleteForm: false,
  permissions: {},
  form: {},
  questions: [],
  setQuestions: async () => {},
  setForm: async () => {},
  updateForm: async () => {},
  updateFormVisibility: async () => {},
  deleteForm: async () => {},
  getQuestion: async () => {},
  readQuestions: async () => {},
  createQuestion: async ({}) => false,
  updateQuestion: async ({}) => false,
  deleteQuestion: async () => false,
}

const CustomFormBuilderContext = createContext<CustomFormBuilderProps>(defaultValues)

export default CustomFormBuilderContext
